// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__37CG5","errors":"Errors_errors__2_ZJO"};